import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faCalendarDays,
  faCalendarCheck,
  faChartLine,
  faClock,
  faComments,
  faDownload,
  faEnvelope,
  faPhone,
  faShieldHalved,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const IndexPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileMenuOpen(open => !open);

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-primary-600 to-primary-700 rounded-lg flex items-center justify-center text-white">
                <FontAwesomeIcon icon={faCalendarCheck} className="text-lg" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900">Reservare</h1>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <a href="#features" className="text-gray-700 hover:text-primary-600 font-medium transition-colors">
                Co umí
              </a>
              <a href="#whatsapp" className="text-gray-700 hover:text-primary-600 font-medium transition-colors">
                WhatsApp + AI
              </a>
              <a href="#kontakt" className="text-gray-700 hover:text-primary-600 font-medium transition-colors">
                Kontakt
              </a>
              <Link to="/login" className="bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 transition-colors font-medium">
                Přihlásit se
              </Link>
            </div>

            <div className="md:hidden">
              <button onClick={toggleMobileMenu} className="text-gray-700 hover:text-primary-600">
                <FontAwesomeIcon icon={isMobileMenuOpen ? faXmark : faBars} className="text-xl" />
              </button>
            </div>
          </div>
        </nav>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
            <div className="px-4 py-4 space-y-4">
              <a href="#features" className="block text-gray-700 py-2" onClick={() => setIsMobileMenuOpen(false)}>Co umí</a>
              <a href="#whatsapp" className="block text-gray-700 py-2" onClick={() => setIsMobileMenuOpen(false)}>WhatsApp + AI</a>
              <a href="#kontakt" className="block text-gray-700 py-2" onClick={() => setIsMobileMenuOpen(false)}>Kontakt</a>
              <Link
                to="/login"
                className="block bg-primary-600 text-white px-6 py-2 rounded-lg text-center mt-4"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Přihlásit se
              </Link>
            </div>
          </div>
        )}
      </header>

      {/* Hero */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-primary-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <span className="inline-block bg-primary-100 text-primary-700 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide">
                Rezervační systém pro salony
              </span>
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Rezervace, klienti a komunikace na jednom místě
              </h1>
              <p className="text-xl text-gray-600">
                Kalendář, evidence zákazníků a inteligentní příjem zpráv z WhatsApp.
                Méně klikání, méně zmeškaných termínů, víc času na klienty.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#kontakt"
                  className="bg-primary-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-700 transition-colors text-center"
                >
                  Domluvit ukázku
                </a>
                <Link
                  to="/login"
                  className="border-2 border-primary-600 text-primary-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-50 transition-colors text-center"
                >
                  Přihlášení do aplikace
                </Link>
              </div>
              <div className="flex items-center gap-6 text-sm text-gray-600 pt-2">
                <span className="inline-flex items-center gap-2">
                  <FontAwesomeIcon icon={faShieldHalved} className="text-green-600" />
                  GDPR-friendly, vlastní hosting
                </span>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl shadow-2xl p-6 transform rotate-2 hover:rotate-0 transition-transform">
                <div className="space-y-3">
                  <div className="flex items-center gap-3 p-3 bg-green-50 rounded-lg">
                    <div className="w-2 h-12 bg-green-500 rounded-full" />
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">10:00 — Jana Nováková</p>
                      <p className="text-sm text-gray-600">Střih a foukaná · Anna</p>
                    </div>
                    <span className="text-xs px-2 py-1 bg-green-200 text-green-800 rounded">Potvrzeno</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-blue-50 rounded-lg">
                    <div className="w-2 h-12 bg-blue-500 rounded-full" />
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">11:30 — Petr Svoboda</p>
                      <p className="text-sm text-gray-600">Holení · Tomáš</p>
                    </div>
                    <span className="text-xs px-2 py-1 bg-blue-200 text-blue-800 rounded">Probíhá</span>
                  </div>
                  <div className="flex items-center gap-3 p-3 bg-amber-50 rounded-lg">
                    <div className="w-2 h-12 bg-amber-500 rounded-full" />
                    <div className="flex-1">
                      <p className="font-semibold text-gray-900">13:00 — WhatsApp od klienta</p>
                      <p className="text-sm text-gray-600">AI rozpoznala: REZERVACE · pátek odpoledne</p>
                    </div>
                    <span className="text-xs px-2 py-1 bg-amber-200 text-amber-800 rounded">Nový</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Co Reservare už dnes umí</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Žádné sliby do budoucna. Tady je seznam funkcí, které jsou v ostré aplikaci a používají je salony.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <FeatureCard
              icon={faCalendarDays}
              color="primary"
              title="Kalendář rezervací"
              text="Denní/týdenní pohled, drag & drop přesun, blokovaný čas, detekce konfliktů. Per-zaměstnanec sloupce."
            />
            <FeatureCard
              icon={faUsers}
              color="purple"
              title="Evidence zákazníků"
              text="Databáze klientů, historie návštěv, poznámky a přílohy ke kartě, vyhledávání podle telefonu nebo emailu."
            />
            <FeatureCard
              icon={faClock}
              color="blue"
              title="Pracovní doba a absence"
              text="Pracovní doba per zaměstnanec, dovolené, nemoci a blokované časy. Konfliktní rezervace se nabídnou ke zrušení."
            />
            <FeatureCard
              icon={faShieldHalved}
              color="green"
              title="Role: majitel / recepce / pracovník"
              text="Granulární oprávnění. Pracovník vidí jen svůj kalendář, recepce zakládá rezervace, majitel vidí finance."
            />
            <FeatureCard
              icon={faEnvelope}
              color="amber"
              title="E-mailové notifikace"
              text="Klient dostane potvrzení rezervace nebo zprávu o jejím zrušení. Šablony přes Mailjet."
            />
            <FeatureCard
              icon={faDownload}
              color="indigo"
              title="Export pro účetní"
              text="Stáhni rezervace v CSV, Excelu nebo PDF za libovolné období. Ideální pro měsíční uzávěrku."
            />
          </div>
        </div>
      </section>

      {/* WhatsApp + AI — flagship feature */}
      <section id="whatsapp" className="py-20 bg-gradient-to-br from-amber-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <span className="inline-block bg-amber-200 text-amber-900 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide">
                Co jiní nemají
              </span>
              <h2 className="text-4xl font-bold text-gray-900">WhatsApp s AI rozpoznáním</h2>
              <p className="text-lg text-gray-700">
                Klient napíše „Můžu se v pátek odpoledne dostat na střih?" — Reservare zprávu přijme,
                Claude (Anthropic) z ní vytáhne <strong>záměr (rezervace), službu, datum a čas</strong>,
                propojí ji s kartou klienta a obsluha v adminu vidí strukturovaný náhled.
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faComments} className="text-amber-600 mt-1" />
                  <span>Příchozí zprávy přes Meta WhatsApp Cloud API jsou vidět v adminu během sekund.</span>
                </li>
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faChartLine} className="text-amber-600 mt-1" />
                  <span>AI klasifikuje typ zprávy (rezervace / dotaz / zrušení) s mírou jistoty.</span>
                </li>
                <li className="flex items-start gap-3">
                  <FontAwesomeIcon icon={faEnvelope} className="text-amber-600 mt-1" />
                  <span>Automatická odpověď „děkujeme, ozveme se" a e-mail obsluze, vše konfigurovatelné.</span>
                </li>
              </ul>
              <p className="text-sm text-gray-600">
                Jako provider je možné Anthropic Claude i OpenAI GPT — přepíná se konfigurací.
              </p>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6 space-y-4">
              <div className="bg-gray-100 rounded-lg p-4">
                <p className="text-xs text-gray-500 uppercase mb-1">WhatsApp · 14:23</p>
                <p className="text-gray-900">Ahoj, dalo by se v pátek udělat barvení? Nejlépe odpoledne 🙏</p>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm">
                <p className="font-semibold text-amber-900 mb-2">AI extrakce</p>
                <div className="grid grid-cols-2 gap-2 text-gray-700">
                  <span className="text-gray-500">Záměr</span><span className="font-medium">REZERVACE</span>
                  <span className="text-gray-500">Služba</span><span className="font-medium">barvení</span>
                  <span className="text-gray-500">Datum</span><span className="font-medium">pátek (2026-05-08)</span>
                  <span className="text-gray-500">Čas</span><span className="font-medium">odpoledne</span>
                  <span className="text-gray-500">Jistota</span><span className="font-medium">94 %</span>
                </div>
              </div>
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-sm">
                <p className="font-semibold text-green-900 mb-1">Auto-odpověď klientovi</p>
                <p className="text-gray-700">Děkujeme za zprávu, brzy se vám ozveme s konkrétním časem.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pro koho */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Pro koho je Reservare</h2>
            <p className="text-xl text-gray-600">Kadeřnictví, barber shopy, kosmetika, masáže, manikúra — všude, kde se objednává na termín.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <SegmentCard label="Malý salon" desc="1–3 lidi, jeden majitel. Setup do hodiny, bez složitých rolí." />
            <SegmentCard label="Střední provoz" desc="Recepce + 5–10 pracovníků. Role oddělí kompetence, finance vidí jen majitel." />
            <SegmentCard label="Multi-salon" desc="Pro řetězce — admin platforma s přehledem napříč pobočkami." />
          </div>
        </div>
      </section>

      {/* Kontakt CTA */}
      <section id="kontakt" className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-4">Zkusíte to s námi?</h2>
          <p className="text-xl text-gray-300 mb-10">
            Reservare je v aktivním vývoji — pilotní salony běží zdarma. Napište a domluvíme se na nasazení.
          </p>
          <div className="grid md:grid-cols-2 gap-6 text-left">
            <a href="mailto:info@reservare.cz" className="bg-gray-800 hover:bg-gray-700 transition-colors rounded-xl p-6 flex items-start gap-4">
              <FontAwesomeIcon icon={faEnvelope} className="text-primary-400 text-2xl mt-1" />
              <div>
                <p className="text-sm text-gray-400">E-mail</p>
                <p className="text-lg font-semibold">info@reservare.cz</p>
                <p className="text-sm text-gray-400 mt-1">Odpovídáme do druhého pracovního dne.</p>
              </div>
            </a>
            <Link to="/site/contact" className="bg-gray-800 hover:bg-gray-700 transition-colors rounded-xl p-6 flex items-start gap-4">
              <FontAwesomeIcon icon={faPhone} className="text-primary-400 text-2xl mt-1" />
              <div>
                <p className="text-sm text-gray-400">Kontaktní formulář</p>
                <p className="text-lg font-semibold">Vyplnit dotaz</p>
                <p className="text-sm text-gray-400 mt-1">Pár otázek k vašemu provozu, ať víme co potřebujete.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-950 text-gray-400 py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm">
            <div>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-8 h-8 bg-gradient-to-r from-primary-600 to-primary-700 rounded-lg flex items-center justify-center text-white">
                  <FontAwesomeIcon icon={faCalendarCheck} />
                </div>
                <span className="font-semibold text-white">Reservare</span>
              </div>
              <p>Rezervační systém pro malé a střední salony.</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-3">Provozovatel</h3>
              <p className="font-medium text-gray-300">INDIVIDUAL STARTUP s.r.o.</p>
              <p>Rybná 716/24, Staré Město</p>
              <p>110 00 Praha</p>
              <p className="mt-2">IČO: 08949671</p>
              <p>DIČ: CZ08949671</p>
              <p>Datová schránka: mrrrt2</p>
              <p className="mt-2 text-xs text-gray-500">Zapsáno v obchodním rejstříku vedeném Městským soudem v Praze.</p>
            </div>
            <div>
              <h3 className="text-white font-semibold mb-3">Kontakt</h3>
              <p>
                <a href="mailto:info@reservare.cz" className="hover:text-white transition-colors">info@reservare.cz</a>
              </p>
              <div className="flex flex-col gap-2 mt-4">
                <Link to="/login" className="hover:text-white transition-colors">Přihlášení</Link>
                <Link to="/contact" className="hover:text-white transition-colors">Kontaktní formulář</Link>
                <Link to="/prices" className="hover:text-white transition-colors">Ceník</Link>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-6 text-xs text-gray-500 flex flex-col md:flex-row items-center justify-between gap-2">
            <p>© {new Date().getFullYear()} INDIVIDUAL STARTUP s.r.o. Všechna práva vyhrazena.</p>
            <p>Reservare je registrovaná značka provozovatele.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

interface FeatureCardProps {
  icon: typeof faCalendarDays;
  color: 'primary' | 'green' | 'blue' | 'purple' | 'amber' | 'indigo';
  title: string;
  text: string;
}

const colorMap: Record<FeatureCardProps['color'], { bg: string; iconBg: string; icon: string }> = {
  primary: { bg: 'bg-primary-50', iconBg: 'bg-primary-600', icon: 'text-white' },
  green: { bg: 'bg-green-50', iconBg: 'bg-green-600', icon: 'text-white' },
  blue: { bg: 'bg-blue-50', iconBg: 'bg-blue-600', icon: 'text-white' },
  purple: { bg: 'bg-purple-50', iconBg: 'bg-purple-600', icon: 'text-white' },
  amber: { bg: 'bg-amber-50', iconBg: 'bg-amber-600', icon: 'text-white' },
  indigo: { bg: 'bg-indigo-50', iconBg: 'bg-indigo-600', icon: 'text-white' },
};

const FeatureCard = ({ icon, color, title, text }: FeatureCardProps) => {
  const c = colorMap[color];
  return (
    <div className={`${c.bg} rounded-2xl p-6 hover:shadow-lg transition-all`}>
      <div className={`w-12 h-12 ${c.iconBg} rounded-xl flex items-center justify-center mb-4`}>
        <FontAwesomeIcon icon={icon} className={`${c.icon} text-xl`} />
      </div>
      <h3 className="text-lg font-bold text-gray-900 mb-2">{title}</h3>
      <p className="text-sm text-gray-700 leading-relaxed">{text}</p>
    </div>
  );
};

const SegmentCard = ({ label, desc }: { label: string; desc: string }) => (
  <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
    <h3 className="text-lg font-bold text-gray-900 mb-2">{label}</h3>
    <p className="text-sm text-gray-600">{desc}</p>
  </div>
);

export default IndexPage;
